import { render, staticRenderFns } from "./RelativeTimePunters.vue?vue&type=template&id=2ff0918c"
import script from "./RelativeTimePunters.vue?vue&type=script&lang=js"
export * from "./RelativeTimePunters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports